import React, { useState, useEffect } from "react";
import axios from "axios";
import approved from "../../../assets/Icon/approved.png";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const AdminApprovedFanGroup = () => {
  const [event_data, setFanLiveGroup] = useState([]);
  const [fanApproved, setFanApproved] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get(`/api/admin/fan/group/adminlist/status`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setFanApproved(res.data.fanLiveGroupCount);
        setFanLiveGroup(res.data.fanLiveGroup);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Approved Fan Group"
        image={approved}
        count={event_data.length}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AllModuleData
          data={event_data}
          urlLink={`/superstar-admin/fangroup/view`}
          fan={"true"}
        />
      )}
    </>
  );
};

export default AdminApprovedFanGroup;
